import { render, staticRenderFns } from "./ModalLeadFile.vue?vue&type=template&id=66cfc3f1"
import script from "./ModalLeadFile.vue?vue&type=script&lang=js"
export * from "./ModalLeadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports